import { ViewChangelog } from '@xeetr/types/models'
import parse from 'html-react-parser'
import { Loader2 } from 'lucide-react'
import { useEffect } from 'react'

import { useCustomers } from '@/hooks/useCustomers'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
  bookingId: string
}

const ChangelogDialog = ({ open, onOpenChange, bookingId }: Props) => {
  const { changelogsLoading, changelogs, loadChangelogs } = useCustomers()

  useEffect(() => {
    if (open && bookingId) {
      loadChangelogs(bookingId)
    }
  }, [open, bookingId, loadChangelogs])

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl">
        <DialogHeader>
          <DialogTitle>Änderungshistorie</DialogTitle>
        </DialogHeader>
        {changelogsLoading ? (
          <div className="flex justify-center p-4">
            <Loader2 className="h-8 w-8 animate-spin" />
          </div>
        ) : (
          <div className="max-h-96 overflow-y-auto">
            {changelogs.length === 0 ? (
              <p className="text-muted-foreground text-center">
                Keine Änderungshistorie vorhanden.
              </p>
            ) : (
              <div className="space-y-4">
                {changelogs.map((changelog: ViewChangelog, index: number) => (
                  <div key={changelog.id || index} className="rounded-lg border p-4">
                    <div className="mb-2 flex items-start justify-between">
                      <span className="font-medium">{changelog.time}</span>
                      <span className="text-muted-foreground text-sm">{changelog.user}</span>
                    </div>
                    <div className="text-sm">
                      {changelog.changes?.map((change: string, changeIndex: number) => (
                        <div key={changeIndex} className="mb-1">
                          {typeof change === 'string' ? parse(change) : change}
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  )
}
export default ChangelogDialog
